module.exports = "<div ng-if=\"ctrl.pageNotFound\" class=\"{{ctrl.baseContainerClass}}\">\n  <br/>\n  <div class=\"alert alert-dismissible alert-warning\">\n    <i class=\"fa fa-fw fa-4x fa-meh-o\" style=\"float:left\"></i>\n    <h4>Oops! Page Not Found</h4>\n    <p>The page you are looking for is not (longer) available.</p>\n  </div>\n</div>\n\n<div ng-hide=\"ctrl.pageNotFound\" bind-dynamic-page=\"ctrl.html\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/~ap/app/dynamic-pages/view/dynamic-page.html
// module id = 831
// module chunks = 0